export type ToolbarLayout = 'mediaRecorderAndPlayer' | 'mediaSourceAndPlayer' | 'mediaRecorder' | 'mediaPlayer' | 'mediaSource' | 'noMedia'

type GetToolbarLayoutParams = {
    isMediaRecorderAvailable: boolean
    isMediaPlayerAvailable: boolean
    isMediaSourceAvailable: boolean
}
export const getToolbarLayout = ({
    isMediaRecorderAvailable,
    isMediaPlayerAvailable,
    isMediaSourceAvailable,
}: GetToolbarLayoutParams): ToolbarLayout => {
    if (isMediaRecorderAvailable && isMediaPlayerAvailable) {
        return 'mediaRecorderAndPlayer'
    }
    if (isMediaSourceAvailable && isMediaPlayerAvailable) {
        return 'mediaSourceAndPlayer'
    }
    if (isMediaRecorderAvailable) {
        return 'mediaRecorder'
    }
    if (isMediaPlayerAvailable) {
        return 'mediaPlayer'
    }
    if (isMediaSourceAvailable) {
        return 'mediaSource'
    }

    return 'noMedia'
}
